import type { RouteObject } from 'react-router';

import { commentsRoute } from './comments/comments.route';

/**
 * The moderation area's one route.
 *
 * It held three. Two of them — `/reports` and `/reports/:caseId` — were the case
 * queue and the case detail read through a `caseType=CONTENT_REPORT` filter: the
 * same records, from the same service, at the same two depths, under a second set
 * of URLs and a second set of words for the same four states. One queue is what
 * the catalog declares, and the console now draws one: the report's own decision
 * — dismiss, unpublish, delete, and the block rider — moved onto the case detail,
 * where the endpoint that takes it (`POST /admin/cases/{id}:resolve`) always
 * lived.
 *
 * What stays here is the one surface that was never the same record: the comment
 * queue is `backend-engagement`'s rows, and it shares this folder because it
 * shares an operator's job rather than a payload.
 *
 * The pack's `moderation/` bucket never reaches a URL: the route is `/comments`.
 */
export const moderationRoutes: RouteObject[] = [commentsRoute];
